import { ErrorType } from '../../models/HttpError';
import { ContractStageItemViewModel } from '../../models/Entities/Contracts/ContractStageItemViewModel';
import {
    CreateContractStageItemCommand,
    UpdateContractStageItemCommand
} from '../../services/ContractStageItem.Services';

export const CONTRACTSTAGEITEM_GET_ALL_REQUEST = 'CONTRACTSTAGEITEM_GET_ALL_REQUEST';
export const CONTRACTSTAGEITEM_GET_ALL_SUCCESS = 'CONTRACTSTAGEITEM_GET_ALL_SUCCESS';
export const CONTRACTSTAGEITEM_GET_ALL_FAILURE = 'CONTRACTSTAGEITEM_GET_ALL_FAILURE';

export interface ContractStageItemGetAllRequestAction {
    type: typeof CONTRACTSTAGEITEM_GET_ALL_REQUEST;
    contractStageId: number;
}

export interface ContractStageItemGetAllSuccessAction {
    type: typeof CONTRACTSTAGEITEM_GET_ALL_SUCCESS;
    contractStageId: number;
    payload: ContractStageItemViewModel[];
}

export interface ContractStageItemGetAllFailureAction {
    type: typeof CONTRACTSTAGEITEM_GET_ALL_FAILURE;
    contractStageId: number;
    error: ErrorType;
}

export const CONTRACTSTAGEITEM_GET_BY_ID_REQUEST = 'CONTRACTSTAGEITEM_GET_BY_ID_REQUEST';
export const CONTRACTSTAGEITEM_GET_BY_ID_SUCCESS = 'CONTRACTSTAGEITEM_GET_BY_ID_SUCCESS';
export const CONTRACTSTAGEITEM_GET_BY_ID_FAILURE = 'CONTRACTSTAGEITEM_GET_BY_ID_FAILURE';

export interface ContractStageItemGetByIdRequestAction {
    type: typeof CONTRACTSTAGEITEM_GET_BY_ID_REQUEST;
    contractStageId: number;
    stageItemId: number;
}

export interface ContractStageItemGetByIdSuccessAction {
    type: typeof CONTRACTSTAGEITEM_GET_BY_ID_SUCCESS;
    contractStageId: number;
    payload: ContractStageItemViewModel;
}

export interface ContractStageItemGetByIdFailureAction {
    type: typeof CONTRACTSTAGEITEM_GET_BY_ID_FAILURE;
    contractStageId: number;
    stageItemId: number;
    error: ErrorType;
}

export const CONTRACTSTAGEITEM_CREATE_REQUEST = 'CONTRACTSTAGEITEM_CREATE_REQUEST';
export const CONTRACTSTAGEITEM_CREATE_SUCCESS = 'CONTRACTSTAGEITEM_CREATE_SUCCESS';
export const CONTRACTSTAGEITEM_CREATE_FAILURE = 'CONTRACTSTAGEITEM_CREATE_FAILURE';

export interface ContractStageItemCreateRequestAction {
    type: typeof CONTRACTSTAGEITEM_CREATE_REQUEST;
    contractStageId: number;
    payload: CreateContractStageItemCommand;
}

export interface ContractStageItemCreateSuccessAction {
    type: typeof CONTRACTSTAGEITEM_CREATE_SUCCESS;
    contractStageId: number;
    payload: ContractStageItemViewModel;
}

export interface ContractStageItemCreateFailureAction {
    type: typeof CONTRACTSTAGEITEM_CREATE_FAILURE;
    contractStageId: number;
    error: ErrorType;
}

export const CONTRACTSTAGEITEM_UPDATE_REQUEST = 'CONTRACTSTAGEITEM_UPDATE_REQUEST';
export const CONTRACTSTAGEITEM_UPDATE_SUCCESS = 'CONTRACTSTAGEITEM_UPDATE_SUCCESS';
export const CONTRACTSTAGEITEM_UPDATE_FAILURE = 'CONTRACTSTAGEITEM_UPDATE_FAILURE';

export interface ContractStageItemUpdateRequestAction {
    type: typeof CONTRACTSTAGEITEM_UPDATE_REQUEST;
    contractStageId: number;
    stageItemId: number;
    payload: UpdateContractStageItemCommand;
}

export interface ContractStageItemUpdateSuccessAction {
    type: typeof CONTRACTSTAGEITEM_UPDATE_SUCCESS;
    contractStageId: number;
    payload: ContractStageItemViewModel;
}

export interface ContractStageItemUpdateFailureAction {
    type: typeof CONTRACTSTAGEITEM_UPDATE_FAILURE;
    contractStageId: number;
    stageItemId: number;
    error: ErrorType;
}

export const CONTRACTSTAGEITEM_DELETE_REQUEST = 'CONTRACTSTAGEITEM_DELETE_REQUEST';
export const CONTRACTSTAGEITEM_DELETE_SUCCESS = 'CONTRACTSTAGEITEM_DELETE_SUCCESS';
export const CONTRACTSTAGEITEM_DELETE_FAILURE = 'CONTRACTSTAGEITEM_DELETE_FAILURE';

export interface ContractStageItemDeleteRequestAction {
    type: typeof CONTRACTSTAGEITEM_DELETE_REQUEST;
    contractStageId: number;
    stageItemId: number;
}

export interface ContractStageItemDeleteSuccessAction {
    type: typeof CONTRACTSTAGEITEM_DELETE_SUCCESS;
    contractStageId: number;
    stageItemId: number;
}

export interface ContractStageItemDeleteFailureAction {
    type: typeof CONTRACTSTAGEITEM_DELETE_FAILURE;
    contractStageId: number;
    stageItemId: number;
    error: ErrorType;
}
